export const taxOptions = [{ id: 1, name: "19 %"}, { id: 2, name: "7 %"}];